<template>
	<div>
		<div class="offcanvas-header d-flex justify-content-between align-items-center">
			<h3 class="offcanvas-title" v-if="userLogged">{{userName}}</h3>
			<h3 class="offcanvas-title" v-else>Войдите в личный кабинет</h3>
			<button class="close" type="button" data-dismiss="offcanvas" aria-label="Close"><span aria-hidden="true">&times;</span></button>
		</div>
		<div class="offcanvas-body">
			<div class="offcanvas-body-inner" v-if="userLogged">
				<ul class="contact-list list-group-flush">
					<li>
						<div class="contact-icon"><i class="mx-auto fa fa-user-secret"></i></div>
						<div class="contact-details">
							<a href="/Profile" class="contact-link">
								Перейти в личный кабинет
							</a>
							<span class="contact-label">Там можно посмотреть и редактировать все свои данные</span>
						</div>
					</li>
					<li>
						<div class="contact-icon"><i class="mx-auto fa fa-sign-out"></i></div>
						<div class="contact-details">
							<a href="#" v-on:click="logOut" class="contact-link">
								Выйти
							</a>
							<span class="contact-label">Товары в корзине сохранятся</span>
						</div>
					</li>
				</ul>
			</div>
			<div class="offcanvas-body-inner" v-else>
				<ul class="contact-list list-group-flush">
					<li>
						<div class="contact-icon"><i class="mx-auto mb-1 fa fa-sign-in"></i></div>
						<div class="contact-details">
							<a href="/Identity/Account/SignIn" class="contact-link">
								Войти / Зерегистрироваться
							</a>
							<span class="contact-label">Если вы не помните пароль, восстановить его можно по этой ссылке</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import { actions, getters, namespace } from "User/store/store";
	import { mapGetters, mapActions } from "vuex";

	export default {
		name: "profile-widget",
		computed: {
			...mapGetters(namespace, {
				userName: getters.userName.name,
				userLogged: getters.userLogged.name
			})
		},
		methods: {
			...mapActions(namespace, {
				logOut: actions.logOutUser.name
			})
		}
	}
</script>